export default __webpack_public_path__ + "static/media/img-error-text.331a1f91.svg";